
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:AccountPage:Loaded', function(event){
    setTimeout(function(){
      Flits('.flits-nav-tabs .flits-menu-item a[href*="/tools/recurring/login"]').removeAttr("target");
    },1000);
    setTimeout(function(){
      Flits('.flits-nav-tabs .flits-menu-item a[href*="/shopify/account/"]').removeAttr("target");
    },1000);
  });
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var listToDelete = ['https://e.womenshealthnetwork.com/shopify/account/customer-guarantee.aspx', 'https://e.womenshealthnetwork.com/shopify/account/product-protocols.aspx', 'https://e.womenshealthnetwork.com/shopify/account/get-an-answer.aspx', 'https://e.womenshealthnetwork.com/shopify/account/email-preferences.aspx', 'https://womenshealthnetwork-com.myshopify.com/tools/recurring/login'];
    for (var i = 0; i < settings.navs.length; i++) {
      var obj = settings.navs[i];
      if (listToDelete.indexOf(obj.url) !== -1) {
        settings.navs.splice(i, 1);
        i--;
      }
    }
    var obj = [
      {
        title: 'Manage subscriptions',
        url:'/tools/recurring/login',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: null
      },
      {
        title: 'Customer Guarantee',
        url:'#customerguarantee',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: '<iframe src="https://e.womenshealthnetwork.com/shopify/account/customer-guarantee.aspx"></iframe>'
      },
      {
        title: 'Product Protocols',
        url:'/pages/product-protocols',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: null
      },
      {
        title: 'Get an answer',
        url:'#getananswer',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: '<iframe src="https://e.womenshealthnetwork.com/shopify/account/get-an-answer.aspx"></iframe>'
      },
      {
        title: 'Email preferences',
        url:'#emailPreferences',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: '<iframe src="https://e.womenshealthnetwork.com/shopify/account/email-preferences.aspx"></iframe>'
      }
    ];
      Flits(obj).each(function(index, element){
      	settings.navs.splice(index + 6, 0, element); //here index means position of navigation tab, element means content for tab.
      })
    
  });
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: "Please add your phone country code", pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
}(Flits));
